"use client";

import { useEffect, useRef } from "react";

export default function ScrollProgress() {
  const barRef = useRef<HTMLDivElement>(null);
  const glowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let trigger: any;

    Promise.all([
      import("gsap"),
      import("gsap/ScrollTrigger")
    ]).then(([gsapModule, scrollTriggerModule]) => {
      const gsap = gsapModule.default;
      const ScrollTrigger = scrollTriggerModule.ScrollTrigger;

      gsap.registerPlugin(ScrollTrigger);
      
      gsap.set([barRef.current, glowRef.current], { scaleX: 0, transformOrigin: "left center" });
      
      trigger = ScrollTrigger.create({
        trigger: document.documentElement,
        start: "top top",
        end: "bottom bottom",
        scrub: 0.5, // scrub value gives the smooth spring-like feel
        animation: gsap.to([barRef.current, glowRef.current], {
          scaleX: 1,
          ease: "none"
        })
      });
    });

    return () => {
      if (trigger) trigger.kill();
    };
  }, []);

  return (
    <>
      <div
        ref={barRef}
        className="fixed top-0 left-0 right-0 h-[3.5px] origin-left z-[9999] pointer-events-none bg-gradient-to-r from-teal-500 via-[#0d9488] to-teal-200 shadow-[0_0_12px_rgba(13,148,136,0.6)]"
      />
      
      <div 
        ref={glowRef}
        className="fixed top-0 left-0 right-0 h-[12px] origin-left z-[9998] pointer-events-none bg-gradient-to-r from-teal-500/30 via-[#0d9488]/30 to-teal-200/30 blur-md"
      />
    </>
  );
}
